import { FormControl, FormHelperText } from 'material-ui/Form';
import MuInput, { InputLabel  } from 'material-ui/Input';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import kebabCase from 'kebab-case';

import styles from '../../constants/styles';
import validate from '../../lib/validation';

export class Input extends Component {
  constructor(props) {
    super(props);
    this._dirty = false;
  }

  handleChange(event) {
    const { onChange } = this.props;
    this._dirty = true;
    onChange(event);
  }

  render() {
    const { classes, label, required, type, value, validations,  inputProps } = this.props;
    const id = kebabCase(this.props.label);

    const validationErrors = this._dirty ?  validate(value, validations) : [];

    return (
      <FormControl
        error={ validationErrors.length > 0 }
        fullWidth
        required={ required }
        className={classes.formControl}
      >
        <InputLabel htmlFor={id}>{ label }</InputLabel>
        <MuInput
          inputProps={ inputProps }
          id={ id }
          value={ value }
          onChange={ this.handleChange.bind(this) }
          type={ type }
        />
        {
          validationErrors.map(error => (
            <FormHelperText key={error}>{ error }</FormHelperText>
          ))
        }
      </FormControl>
    );
  }
}

Input.defaultProps = {
  type: 'text'
}

Input.propTypes = {
  classes:     PropTypes.object.isRequired,
  inputProps:  PropTypes.object,
  label:       PropTypes.string.isRequired,
  onChange:    PropTypes.func.isRequired,
  type:        PropTypes.string,
  required:    PropTypes.bool,
  validations: PropTypes.arrayOf(PropTypes.string),
  value:       PropTypes.node,
}

export default withStyles(styles)(Input);



// WEBPACK FOOTER //
// ./src/components/common/Input.js